import { AGENCY_BUNDLE_ID } from './AgencyBundleProducts';
import { twoDecimalFraction } from './helper';
import { getProductPrice } from './productPrices';

const coupons = {
	4372: {
		// Essential Addons Pro
		1: 'momentum20', // Single Website
		3: 'momentum35', // Unlimited Website
		4: 'momentum40', // Lifetime Unlimited
	},
	99658: {
		// NotificationX Pro
		1: 'momentum20', // Individual
		3: 'momentum25', // Business
		4: 'momentum38', // Lifetime Unlimited
	},
	342422: {
		// BetterDocs Pro
		1: 'momentum20', // Starter
		2: 'momentum25', // Innovator
		3: 'momentum33', // Visionary
	},
	78593: {
		// SchedulePress Pro
		1: 'momentum20', // Individual
		3: 'momentum25', // Business
		4: 'momentum38', // Lifetime Unlimited
	},
	414494: {
		// EmbedPress Pro
		1: 'momentum20', // Individual
		2: 'momentum25', // Business
		3: 'momentum38', // Lifetime Unlimited
	},
	764539: {
		// BetterLinks Pro
		1: 'momentum20', // Individual
		2: 'momentum25', // Business (Yearly Unlimited)
		3: 'momentum30', // Agency (Lifetime Unlimited)
	},
	1738966: {
		// BetterPayment Pro
		1: 'momentum20', // Single Site
		2: 'momentum25', // Unlimited Sites
		3: 'momentum30', // Lifetime
	},
	1677666: {
		// Essential Block Pro
		1: 'momentum20', // Starter (1 Site)
		2: 'momentum25', // Innovator (5 Sites)
		3: 'momentum43', // Visionary (100 Sites)
		6: 'momentum38', // Visionary Lifetime (100 Sites)
	},
	[AGENCY_BUNDLE_ID]: {
		// Agency Bundle
		1: 'momentum25', // Yearly Unlimited
		2: 'momentum30', // Lifetime Unlimited
		5: '', // Monthly Unlimited
	},
};

export function getCoupons(downloadId, priceId) {
	return coupons?.[downloadId]?.[priceId] || '';
}

export const agencyMonthly = {
	downloadId: AGENCY_BUNDLE_ID,
	priceId: 5,
	price: getProductPrice(AGENCY_BUNDLE_ID, 5, 'dealPrice'),
	name: 'Agency Bundle Monthly',
	details: function (cartTotal, cartDetails) {
		return `Unlock Agency Bundle Yearly License & get access to 10+ Premium Products for only <b>$29/Month</b>.`;
	},
	savedValue: 2600,
	coupon: getCoupons(AGENCY_BUNDLE_ID, 5),
	lifetime: false,
};

export const agencyYearly = {
	downloadId: AGENCY_BUNDLE_ID,
	priceId: 1,
	price: getProductPrice(AGENCY_BUNDLE_ID, 1, 'dealPrice'),
	name: 'Agency Bundle Yearly',
	details: function (cartTotal, cartDetails) {
		return `Unlock Agency Bundle Yearly License & get access to 10+ Premium Products for only <b>${getRequiredPrice(
			cartTotal,
			this.price
		)}</b>.`;
	},
	savedValue: 2600,
	coupon: getCoupons(AGENCY_BUNDLE_ID, 1),
	lifetime: false,
};
export const agencyLifetime = {
	downloadId: AGENCY_BUNDLE_ID,
	priceId: 2,
	price: getProductPrice(AGENCY_BUNDLE_ID, 2, 'dealPrice'),
	name: 'Agency Bundle Lifetime',
	details: function (cartTotal, cartDetails) {
		if (cartTotal === 0) {
			return `Grab our Agency Bundle Lifetime pack only for <b>${getRequiredPrice(
				cartTotal,
				this.price
			)}</b> and unlock LIFETIME access to 10 advanced WordPress PRO plugins on unlimited websites!`;
		}
		return `Paying ${twoDecimalFraction(cartTotal)} for ${
			cartDetails?.contents?.length
		} product? Grab our Agency Bundle Lifetime pack instead by adding only <b>${getRequiredPrice(
			cartTotal,
			this.price
		)}</b> and unlock LIFETIME access to 10 advanced WordPress PRO plugins on unlimited websites!`;
	},
	savedValue: 13000,
	coupon: getCoupons(AGENCY_BUNDLE_ID, 2),
	lifetime: true,
};

export const upsellProducts = [
	{
		downloadId: 4372,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(4372, 1, 'dealPrice'),
				products: [
					{
						downloadId: 4372,
						priceId: 3,
						price: getProductPrice(4372, 3, 'dealPrice'),
						name: 'Essential Addons Unlimited',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(4372, 3),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(4372, 3, 'dealPrice'),
				products: [
					{
						downloadId: 4372,
						priceId: 4,
						price: getProductPrice(4372, 4, 'dealPrice'),
						name: 'Essential Addons Lifetime Unlimited',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License and Lifetime Updates & Support for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b> .`;
						},
						coupon: getCoupons(4372, 4),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 4,
				price: getProductPrice(4372, 4, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 1738966,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(1738966, 1, 'dealPrice'),
				products: [
					{
						downloadId: 1738966,
						priceId: 2,
						price: getProductPrice(1738966, 2, 'dealPrice'),
						name: 'Better Payment Pro Unlimited',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(1738966, 2),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 2,
				price: getProductPrice(1738966, 1, 'dealPrice'),
				products: [
					{
						downloadId: 1738966,
						priceId: 3,
						price: getProductPrice(1738966, 3, 'dealPrice'),
						name: 'Better Payment Pro Unlimited',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(1738966, 3),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(1738966, 3, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 342422,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(342422, 1, 'dealPrice'),
				products: [
					{
						downloadId: 342422,
						priceId: 2,
						price: getProductPrice(342422, 2, 'dealPrice'),
						name: 'BetterDocs Innovator',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(342422, 2),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 2,
				price: getProductPrice(342422, 2, 'dealPrice'),
				products: [
					{
						downloadId: 342422,
						priceId: 3,
						price: getProductPrice(342422, 3, 'dealPrice'),
						name: 'BetterDocs Visionary',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License and Lifetime Updates & Support for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b> more`;
						},
						coupon: getCoupons(342422, 3),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(342422, 3, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 99658,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(99658, 1, 'dealPrice'),
				products: [
					{
						downloadId: 99658,
						priceId: 3,
						price: getProductPrice(99658, 3, 'dealPrice'),
						name: 'NotificationX Business',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(99658, 3),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(99658, 3, 'dealPrice'),
				products: [
					{
						downloadId: 99658,
						priceId: 4,
						price: getProductPrice(99658, 4, 'dealPrice'),
						name: 'NotificationX Lifetime Unlimited',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License and Lifetime Updates & Support for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(99658, 4),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 4,
				price: getProductPrice(99658, 4, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 414494,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(414494, 1, 'dealPrice'),
				products: [
					{
						downloadId: 414494,
						priceId: 2,
						price: getProductPrice(414494, 2, 'dealPrice'),
						name: 'EmbedPress Business',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(414494, 2),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 2,
				price: getProductPrice(414494, 2, 'dealPrice'),
				products: [
					{
						downloadId: 414494,
						priceId: 3,
						name: 'EmbedPress Lifetime Unlimited',
						price: getProductPrice(414494, 3, 'dealPrice'),
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License and Lifetime Updates & Support for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(414494, 3),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(414494, 3, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 78593,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(78593, 1, 'dealPrice'),
				products: [
					{
						downloadId: 78593,
						priceId: 3,
						price: getProductPrice(78593, 3, 'dealPrice'),
						name: 'SchedulePress Business',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(78593, 3),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(78593, 3, 'dealPrice'),
				products: [
					{
						downloadId: 78593,
						priceId: 4,
						price: getProductPrice(78593, 4, 'dealPrice'),
						name: 'SchedulePress Lifetime Unlimited',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License and Lifetime Updates & Support for only  <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(78593, 4),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 4,
				price: getProductPrice(78593, 4, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 764539,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(764539, 1, 'dealPrice'),
				products: [
					{
						downloadId: 764539,
						priceId: 2,
						price: getProductPrice(764539, 2, 'dealPrice'),
						name: 'BetterLinks Business',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(764539, 2),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 2,
				price: getProductPrice(764539, 2, 'dealPrice'),
				products: [
					{
						downloadId: 764539,
						priceId: 3,
						price: getProductPrice(764539, 3, 'dealPrice'),
						name: 'BetterLinks Agency Lifetime',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License and Lifetime Updates & Support for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(764539, 3),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(764539, 3, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: AGENCY_BUNDLE_ID,
		upsells: [
			{
				priceId: 1,
				products: [
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 5,
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 9791,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(9791, 1, 'dealPrice'),
				products: [
					{
						downloadId: 9791,
						priceId: 3,
						price: getProductPrice(9791, 3, 'dealPrice'),
						name: 'Fleixa PRO Lifetime',
						details: function (cartTotal, cartDetails) {
							return `Get access to Unlimited Sites License and Lifetime Updates & Support for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: '',
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(9791, 3, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
	{
		downloadId: 1677666,
		upsells: [
			{
				priceId: 1,
				price: getProductPrice(1677666, 1, 'dealPrice'),
				products: [
					{
						downloadId: 1677666,
						priceId: 2,
						price: getProductPrice(1677666, 2, 'dealPrice'),
						name: 'Essential Blocks Innovator',
						details: function (cartTotal, cartDetails) {
							return `Get access to 5 Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b>.`;
						},
						coupon: getCoupons(1677666, 2),
						savedValue: '',
						lifetime: false,
					},
					{
						...agencyMonthly,
					},
				],
			},
			{
				priceId: 2,
				price: getProductPrice(1677666, 2, 'dealPrice'),
				products: [
					{
						downloadId: 1677666,
						priceId: 3,
						price: getProductPrice(1677666, 3, 'dealPrice'),
						name: 'Essential Blocks Visionary',
						details: function (cartTotal, cartDetails) {
							return `Get access to 100 Sites License for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b> .`;
						},
						coupon: getCoupons(1677666, 3),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 3,
				price: getProductPrice(1677666, 3, 'dealPrice'),
				products: [
					{
						downloadId: 1677666,
						priceId: 6,
						price: getProductPrice(1677666, 6, 'dealPrice'),
						name: 'Essential Blocks Visionary Lifetime',
						details: function (cartTotal, cartDetails) {
							return `Get access to 100 Sites License, Lifetime Updates & Support for only <b>${getRequiredPrice(
								cartTotal,
								this.price
							)}</b> .`;
						},
						coupon: getCoupons(1677666, 3),
						savedValue: '',
						lifetime: true,
					},
					{
						...agencyLifetime,
					},
				],
			},
			{
				priceId: 6,
				price: getProductPrice(1677666, 6, 'dealPrice'),
				products: [
					{
						...agencyLifetime,
					},
				],
			},
		],
	},
];

function getRequiredPrice(cartTotal, price) {
	if (cartTotal > price || parseInt(cartTotal) === 0) {
		return `$${price}`;
	}
	return `$${(price - cartTotal)?.toFixed(2)} more`;
}
